import React from 'react';

const ErrorMessage = ({ message, onClose }) => {
  return (
    <div className="alert alert-danger alert-dismissible">
      <strong>Error:</strong> {message}
      {onClose && (
        <button type="button" className="btn-close" onClick={onClose}>
          ×
        </button>
      )}
    </div>
  );
};

export default ErrorMessage;
